module.exports = __webpack_public_path__ + "static/ngrok-0af9fb00817b8590de3e4f79140c6b37.png";